<template>
	<div class="header_menu_list">
		
	   <div class="header_menu_left">
	      <div class="header_menu_nav">
	         <div class="mobileClassName" :class="NavSelected == item.id ? 'divActive' : ''" v-for="(item, index) in menuNav" :key="index" @click="SetNavSelected(item)">
					<div class="tozo_hot_box"  v-if="item.icon && item.icon != ''">
					  {{ item.name }}
					  <div class="tozo_hot_img">
							<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
							<!-- <img :src="item.icon"/> -->
					  </div>
					</div>
					<div class="name" v-else>{{ item.name }}</div>
				</div>
	      </div>
			<div class="bottom-box" v-if="userDataShow">
				<div class="userData" v-if="userData.user_id" @click.stop="check_information(userData)">
					<div class="avatar">
					 	<img v-if="userData.avatar && userData.avatar != ''" :src="userData.avatar" alt="TOZO User profile picture"/>
					 	<i v-else class="el-icon-s-custom"></i>
					</div>
					<div class="username">{{userData.nickname ? userData.nickname : ""}}</div>
				</div>
				<div class="log_out_box"v-if="userData.user_id" >
					<div class="log_out" @click.stop="log_out()">{{ $t('nav_box.Account.Sign_out') }}</div>
					<i class="el-icon-arrow-right"></i>
				</div>
				<div class="userData" v-else @click.stop="login_in()">
					<div class="avatar">
						<i class="el-icon-s-custom"></i>
					</div>
					<div class="login_box">{{ $t('nav_box.Account.SIGN_IN') }}</div>
				</div>
				
				<div class="language_box">
					<language></language>
				</div>
			</div>
	   </div>
		
		<div class="header_menu_content">
			
		   <div class="menu_content product" v-if="NavSelected == 'NEW_RELEASES' || NavSelected == 'HEADPHONES' || NavSelected == 'WATCHES' || NavSelected == 'SPEAKERS'">
				<div class="product_list_box">
					<div class="collection_item_box" v-for="(collection, index_pro) in get_product_list.product_collection" :key="index_pro">
						<div class="type_name_box" :class="collection.type_url != '' ? 'type_name_box_pointer' : ''" v-if="collection.type_name && collection.type_name != ''" @click="$go_official_website_page(collection.type_url)">
							<div class="type_name">{{ collection.type_name }}</div>
							<div class="el-icon-arrow-right" v-if="collection.type_url && collection.type_url != ''"></div>
						</div>
					   <div class="item_list_box">
					      <div class="item_box" v-for="(product, index_pro) in collection.product_list" :key="index_pro" @click="$go_official_website_page(product.buy_now_url)">
					         <div class="product_img">
					            <img :src="product.img" :alt="product.name + ' main image'"/>
					         </div>
					         <div class="product_header_tag">
					            {{ product.tag }}
					         </div>
					         <div class="nav_product_name">
					            {{ product.name }}
					         </div>
					      </div>
					   </div>
					</div>
					
					<div class="category-product-all filterate-type" @click="$go_official_website_page(get_product_list.all_list.url)" v-if="get_product_list.all_list && get_product_list.all_list.url">
						<span>{{get_product_list.all_list.name}}</span>
						<span class="el-icon-arrow-right"></span>
					</div>
					
					<div class="category-product-filterate-box" v-if="get_product_list.filter_arr">
						<div class="category-product-filterate-title">{{ get_product_list.filter_arr.title }}</div>
					   <div class="category-product-filterate-text">
					      <div class="filterate-type" @click="$go_official_website_page(filter.url)" v-for="(filter, index_filter) in get_product_list.filter_arr.filter_list" :key="index_filter">
								<span>{{filter.name}}</span>
								<span class="el-icon-arrow-right"></span>
							</div>
					   </div>
					</div>
					
				</div>
			</div>
			
			<!-- SUPPORT -->
		   <div class="menu_content support_box" v-if="NavSelected == 'SUPPORT'">
				<div class="filterate-box">
					<div class="category-product-filterate-title">{{ support.title }}</div>
					<div class="category-product-filterate-text">
						<div class="filterate-type" v-for="(item, index) in support.text_list" :key="index" @click="$go_official_website_page(item.url)">
							<div class="name">{{ item.name }}</div>
							<div class="el-icon-arrow-right"></div>
						</div>
					</div>
				</div>
				<div class="mobile-support-section-iconBox">
					<div class="support-a-item-box" v-for="(item, index) in support.icon_list" :key="index" @click="$go_official_website_page(item.url)">
					   <div class="support-icon-img">
					      <div class="icon" v-html="$get_icon_name(item.icon_name)"></div>
					   </div>
					   <div class="support-icon-name">{{ item.name }}</div>
					</div>
				</div>
			</div>
			
			<!-- EXPLORE -->
		   <div class="menu_content explore_box" v-if="NavSelected == 'EXPLORE'">
				<div class="explore-section-box" v-for="(item, index) in explore_list" :key="index">
				   <div class="explore-section">
				      <div class="filterate-title">{{ item.title }}</div>
				      <div class="filterate-text-box">
							<div class="filterate-text" v-for="(item_t, index_t) in item.text_list" :key="index_t" @click="go_page_url(item_t.url)">
								<div class="name">{{ item_t.name }}</div>
								<div class="el-icon-arrow-right"></div>
							</div>
						</div>
				   </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
let that = ""
import language from './language.vue'
export default {
	// name: 'MenuPc',
	components: { language },

	// props: {
	// 	Post_List: {
	// 		type: Array,
	// 		default: []
	// 	},
	// },
	
	
	data() {
		return {
			userDataShow: true,
			userData: this.$store.state.userinfo,
			NavSelected: "NEW_RELEASES",
			menuNav:[
				{
					name: this.$t('nav_box.title.NEW_RELEASES'),
					id: "NEW_RELEASES",
					type: "",
					pageUrl:"",
					icon:""
				},
				{
					name: this.$t('nav_box.title.HEADPHONES'),
					id: "HEADPHONES",
					type: "",
					pageUrl:"",
					icon:""
				},
				{
					name: this.$t('nav_box.title.WATCHES'),
					id: "WATCHES",
					type: "",
					pageUrl:"",
					icon:""
				},
				{
					name: this.$t('nav_box.title.SPEAKERS'),
					id: "SPEAKERS",
					type: "",
					pageUrl:"",
					icon:""
				},
				// {
				// 	name: this.$t('nav_box.title.VALENTINE_S_DAY'),
				// 	id: "VALENTINE_S_DAY",
				// 	type: "activity",
				// 	pageUrl:"/pages/valentines-day-sale",
				// 	icon:true
				// 	// icon:"https://cdn.shopify.com/s/files/1/0737/0578/3585/files/TOZO_hot.gif?v=1732066200"
				// },
				// {
				// 	name: this.$t('nav_box.title.SOUND_DEALS'),
				// 	id: "SOUND_DEALS",
				// 	type: "activity",
				// 	pageUrl:"/pages/sound-deals",
				// 	icon:true
				// 	// icon:"https://cdn.shopify.com/s/files/1/0737/0578/3585/files/TOZO_hot.gif?v=1732066200"
				// },
				// {
				// 	name: this.$t('nav_box.title.MOTHERS_DAY_SALE'),
				// 	id: "MOTHERS_DAY_SALE",
				// 	type: "activity",
				// 	pageUrl:"/pages/mothers-day-sale",
				// 	icon:"true"
				// },
				// {
				// 	name: this.$t('nav_box.title.HALLOWEEN_SALE'),
				// 	id: "HALLOWEEN_SALE",
				// 	type: "activity",
				// 	pageUrl:"/pages/halloween-sale",
				// 	icon:"true"
				// },
				// {
				// 	name: this.$t('BLACK_FRIDAY'),
				// 	id: "BLACK_FRIDAY",
				// 	type: "activity",
				// 	pageUrl:"/pages/black-friday-cyber-monday-sale",
				// 	icon:"true"
				// },
				// {
				// 	name: this.$t('nav_box.title.MID_YEAR_SALE'),
				// 	id: "MID_YEAR_SALE",
				// 	type: "activity",
				// 	pageUrl:"/pages/mid-year-sale",
				// 	icon:"true"
				// },
				{
					name: this.$t('nav_box.title.SUMMER_DEALS'),
					id: "SUMMER_DEALS",
					type: "activity",
					pageUrl:"/pages/2026-summer-activities",
					icon:"true"
				},
				// {
				// 	name: this.$t('nav_box.title.GAME_DEALS'),
				// 	id: "GAME_DEALS",
				// 	type: "activity",
				// 	pageUrl:"/pages/soccer-match-2026",
				// 	icon:"true"
				// },
				// {
				// 	name: this.$t('nav_box.title.HOT_SALE'),
				// 	id: "HOT_SALE",
				// 	type: "activity",
				// 	pageUrl:"/collections/hot-sales",
				// 	icon:"true"
				// },
				// {
				// 	name: this.$t('nav_box.title.NEW_YEAR_SALE'),
				// 	id: "NEW_YEAR_SALE",
				// 	type: "activity",
				// 	pageUrl:"/pages/new-year-sale",
				// 	icon:"true"
				// },
				// {
				// 	name: this.$t('nav_box.title.CHRISTMAS_SALE'),
				// 	id: "CHRISTMAS_SALE",
				// 	type: "activity",
				// 	pageUrl:"/pages/christmas-sale",
				// 	icon:"true"
				// },
				// {
				// 	name: this.$t('nav_box.title.BACK_TO_SCHOOL'),
				// 	id: "BACK_TO_SCHOOL",
				// 	type: "activity",
				// 	pageUrl:"/pages/back-to-school",
				// 	icon:"true"
				// },
				// {
				// 	name: this.$t('nav_box.title.SUMMER_SALE'),
				// 	id: "SUMMER_SALE",
				// 	type: "activity",
				// 	pageUrl:"/pages/summer-sale",
				// 	icon:"true"
				// },
				// {
				// 	name: this.$t('nav_box.title.PRIME_DAY'),
				// 	id: "PRIME_DAY",
				// 	type: "activity",
				// 	pageUrl:"/pages/prime-day-deals",
				// 	icon:"true"
				// },
				// {
				// 	name: this.$t('nav_box.title.INDEPENDENCE_DAY'),
				// 	id: "INDEPENDENCE_DAY",
				// 	type: "activity",
				// 	pageUrl:"/pages/independence-day-sale",
				// 	icon:"true"
				// },
				// {
				// 	name: this.$t('nav_box.title.FATHERS_DAY'),
				// 	id: "FATHERS_DAY",
				// 	type: "activity",
				// 	pageUrl:"/pages/fathers-day-sale",
				// 	icon:"true"
				// },
				// {
				// 	name: this.$t('nav_box.title.TOZO_COUPON'),
				// 	id: "TOZO_COUPON",
				// 	type: "activity",
				// 	pageUrl:"/pages/coupon",
				// 	icon:"true"
				// },
				{
					name: this.$t('nav_box.title.SUPPORT'),
					id: "SUPPORT",
					type: "",
					pageUrl:"",
					icon:""
				},
				{
					name: this.$t('nav_box.title.EXPLORE'),
					id: "EXPLORE",
					type: "",
					pageUrl:"",
					icon:""
				}
			],
			ficationActive: "EARBUDS",
			get_product_list:[],
			product_arr:[
				{
					series: "NEW_RELEASES",
					series_url: "/collections/new-releases",
					product_collection:[
						{
							id: "NEW_RELEASES",
							type_name: this.$t('nav_box.title.NEW_RELEASES'),
							type_url: "",
							product_list:[
								// {
								// 	name: "TOZO Golden X1",
								// 	buy_now_url: "",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_X1_galaxy_black.png?v=1722477829",
								// 	// img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_X1_new.webp?v=1720092939"
								// 	tag: "",
								// 	type: []
								// },
								// {
								// 	name: "TOZO VIZO V1",
								// 	buy_now_url: "/products/tozo-vizo-v1",
								// 	img: "https://cdn.shopify.com/s/files/1/0766/6453/7387/files/TOZO_VIZO_V1_nav.png?v=1765879434",
								// 	tag: "",
								// 	type: []
								// },
								// {
								// 	name: "TOZO NC20",
								// 	buy_now_url: "/products/nc20",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_nc20_new.png?v=1762398299",
								// 	tag: "",
								// 	type: []
								// },
								{
									name: "TOZO NC9 Pro",
									buy_now_url: "/products/tozo-nc9-pro-active-noise-cancelling-wireless-earbuds-ldac-hi-res-audio",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC9_Pro.png?v=1789463963",
									tag: "",
									type: []
								},
								{
									name: "TOZO VIZO Z1 Pro",
									buy_now_url: "/products/tozo-vizo-z1-pro",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/TOZO_VIZO_Z1_Pro_nav.png?v=1775544615",
									tag: "",
									type: []
								},
								{
									name: "TOZO Open X2 Pro",
									buy_now_url: "/products/tozo-open-x2-pro",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_Open_X2_Pro.png?v=1784613404",
									tag: "",
									type: []
								},
								{
									name: "TOZO NC20 Pro",
									buy_now_url: "/products/nc20-pro",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_nc20pro_new.png?v=1762916272",
									tag: "",
									type: []
								},
								{
									name: "TOZO HT3",
									buy_now_url: "/products/ht3",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_ht3_new.png?v=1758792493",
									tag: "",
									type: []
								},
								{
									name: "TOZO OpenWear",
									buy_now_url: "/products/openwear",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_openwear_new.png?v=1760605303",
									tag: "",
									type: ["OPEN-EAR"]
								},
								// new nc9
								// {
								// 	name: "TOZO NC9",
								// 	buy_now_url: "/products/2024-hybrid-active-noise-cancelling-wireless-earbuds",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC9_new.png?v=1739168680",
								// 	tag: "",
								// 	type: []
								// },
								// {
								// 	name: "TOZO VIZO Z1",
								// 	buy_now_url: "/products/tozo-vizo-z1",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/TOZO_VIZO_Z1_nav.png?v=1775544615",
								// 	tag: "",
								// 	type: []
								// },
								// {
								// 	name: "TOZO S8",
								// 	buy_now_url: "/products/s8-smartwatch",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_s8_new.png?v=1755086820",
								// 	tag: "",
								// 	type: []
								// },
								// {
								// 	name: "TOZO OpenOrb",
								// 	buy_now_url: "/products/openorb",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_openorb_new.png?v=1755086820",
								// 	tag: "",
								// 	type: []
								// },
								// {
								// 	name: "TOZO Open EarRing",
								// 	buy_now_url: "/products/openearring-headphone",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/tozo-open-earring.png?v=1728989140",
								// 	tag: "",
								// 	type: []
								// },
								// {
								// 	name: "TOZO Open Buds",
								// 	buy_now_url: "/products/open-buds",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_Openbuds.webp?v=1720092872",
								// 	tag: "",
								// 	type: []
								// },
								// {
								// 	name: "TOZO NC9",
								// 	buy_now_url: "/products/nc9",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_nc9.webp?v=1720092872",
								// 	tag: "",
								// 	type: []
								// },
								// {
								// 	name: "TOZO HT2",
								// 	buy_now_url: "/products/ht2",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_HT2.webp?v=1720092872",
								// 	tag: "",
								// 	type: []
								// },
							]
						}
					],
					classification: [],
					all_list:{
						name: this.$t('nav_box.HEADPHONES.Shop_All_Headphones'),
						url: "/collections/new-releases"
					},
					filter_list:[]
				},
				{
					series: "HEADPHONES",
					series_url: "/collections/headphones",
					product_collection:[
						{
							id: "EARBUDS",
							type_name: this.$t('nav_box.HEADPHONES.EARBUDS'),
							type_url: "/collections/earbuds",
							product_list:[
								
								{
									name: "TOZO NC20 Pro",
									buy_now_url: "/products/nc20-pro",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_nc20pro_new.png?v=1762916272",
									tag: "",
									type: ["EARBUDS"]
								},
								{
									name: "TOZO Golden X1",
									buy_now_url: "/products/golden-x1",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_X1_galaxy_black.png?v=1722477829",
									tag: "",
									type: ["EARBUDS"]
								},
								{
									name: "TOZO NC20",
									buy_now_url: "/products/nc20",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_nc20_new.png?v=1762398299",
									tag: "",
									type: ["EARBUDS"]
								},
								// new nc9
								{
									name: "TOZO NC9",
									buy_now_url: "/products/2024-hybrid-active-noise-cancelling-wireless-earbuds",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC9_new.png?v=1739168680",
									tag: "",
									type: ["EARBUDS"]
								},
								// {
								// 	name: "TOZO NC9",
								// 	buy_now_url: "/products/nc9",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_nc9.webp?v=1720092872",
								// 	tag: "",
								// 	type: ["EARBUDS"]
								// },
								{
									name: "TOZO NC3",
									buy_now_url: "/products/nc3-headphone",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC3.png?v=1739168680",
									tag: "",
									type: ["EARBUDS"]
								},
								// {
								// 	name: "TOZO NC2",
								// 	buy_now_url: "/products/nc2",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC2.png?v=1722477828",
								// 	tag: "",
								// 	type: ["EARBUDS"]
								// },
								{
									name: "TOZO A1",
									buy_now_url: "/products/a1",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_A1.png?v=1740017051",
									tag: "",
									type: ["EARBUDS"]
								},
								// {
								// 	name: "TOZO E1",
								// 	buy_now_url: "/products/e1-earbud",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_E1.png?v=1740017052",
								// 	tag: "",
								// 	type: ["EARBUDS"]
								// },
								// {
								// 	name: "TOZO T20",
								// 	buy_now_url: "/products/t20",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_T20.png?v=1721205332",
								// 	tag: "",
								// 	type: ["EARBUDS"]
								// },
							],
						},
						{
							id: "OPEN-EAR",
							type_name: this.$t('nav_box.HEADPHONES.OPEN_EAR'),
							type_url: "/collections/open-ear-headphones",
							product_list:[	
								{
									name: "TOZO Open X2 Pro",
									buy_now_url: "/products/tozo-open-x2-pro",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_Open_X2_Pro.png?v=1784613404",
									tag: "",
									type: ["OPEN-EAR"]
								},
								{
									name: "TOZO Open EarRing",
									buy_now_url: "/products/openearring-headphone",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/tozo-open-earring.png?v=1728989140",
									tag: "",
									type: ["OPEN-EAR"]
								},
								{
									name: "TOZO Open Buds",
									buy_now_url: "/products/open-buds",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_Openbuds.webp?v=1720092872",
									tag: "",
									type: ["OPEN-EAR"]
								},
								{
									name: "TOZO OpenWear",
									buy_now_url: "/products/openwear",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_openwear_new.png?v=1760605303",
									tag: "",
									type: ["OPEN-EAR"]
								},
								{
									name: "TOZO OpenEgo",
									buy_now_url: "/products/openego",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_OpenEgo.webp?v=1720092872",
									tag: "",
									type: ["OPEN-EAR"]
								},
								{
									name: "TOZO OpenReal",
									buy_now_url: "/products/openreal",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_OpenReal.webp?v=1720092872",
									tag: "",
									type: ["OPEN-EAR"]
								},
								// {
								// 	name: "TOZO OpenOrb",
								// 	buy_now_url: "/products/openorb",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_openorb_new.png?v=1755086820",
								// 	tag: "",
								// 	type: []
								// },
						],
					},
					{
						id: "OVER-EAR",
						type_name: this.$t('nav_box.HEADPHONES.OVER_EAR'),
						type_url: "/collections/headphones?gf_85670=Over-Ear",
						product_list:[
								{
									name: "TOZO HT3",
									buy_now_url: "/products/ht3",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_ht3_new.png?v=1758792493",
									tag: "",
									type: ["OVER-EAR"]
								},
								{
									name: "TOZO HT2",
									buy_now_url: "/products/ht2",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_HT2.webp?v=1720092872",
									tag: "",
									type: ["OVER-EAR"]
								},
								{
									name: "TOZO HA1",
									buy_now_url: "/products/ha1-headphone",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_HA1.png?v=1727417350",
									tag: "",
									type: ["OVER-EAR"]
								},
							],
						},
					],
					classification: [
						{
							id: "EARBUDS", 
							name: this.$t('nav_box.HEADPHONES.EARBUDS'),
							url: "/collections/earbuds"
						},
						{
							id: "OPEN-EAR",
							name: this.$t('nav_box.HEADPHONES.OPEN_EAR'),
							url: "/collections/open-ear-headphones"
						},
						{
							id: "OVER-EAR",
							name: this.$t('nav_box.HEADPHONES.OVER_EAR'),
							url: "/collections/headphones?gf_85670=Over-Ear"
						}
					],
					all_list:{
						name: this.$t('nav_box.HEADPHONES.Shop_All_Headphones'),
						url: "/collections/headphones"
					},
					filter_arr: {
						title: "FILTERING",
						filter_list:[
							// {
							// 	name: this.$t('nav_box.HEADPHONES.Active_Noise_Cancelling'),
							// 	url: "/collections/headphones?gf_82588=Active+Noise+Cancelling",
							// },
							// {
							// 	name: this.$t('nav_box.HEADPHONES.Wireless_Charging'),
							// 	url: "/collections/headphones?gf_82588=Wireless+Charging",
							// },
							
							{
								name: this.$t('nav_box.HEADPHONES.Active_Noise_Cancelling'),
								url: "/collections/noise-canceling-earbuds",
							},
							{
								name: this.$t('nav_box.HEADPHONES.Fitness'),
								url: "/collections/fitness",
							},
							{
								name: this.$t('nav_box.HEADPHONES.Hi_Res_Audio'),
								url: "/collections/hi-res-audio-headphones",
							},
							{
								name: this.$t('nav_box.HEADPHONES.Premium_Call_Quality'),
								url: "/collections/premium-headphones",
							},
							{
								name: this.$t('nav_box.HEADPHONES.Gaming'),
								url: "/collections/gaming-headphones",
							},
							{
								name: this.$t('nav_box.HEADPHONES.Waterproof_Earbuds'),
								url: "/collections/waterproof-earbuds",
							},
							{
								name: this.$t('nav_box.HEADPHONES.Translate_Earbuds'),
								url: "/collections/translate-earbuds",
							},
						]
					}
				},
				{
					series: "WATCHES",
					series_url: "/collections/watches",
					product_collection:[
						{
							id: "WATCHES",
							type_name: this.$t('nav_box.title.WATCHES'),
							type_url: "",
							product_list:[
								{
									name: "TOZO S8",
									buy_now_url: "/products/s8-smartwatch",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_s8_new.png?v=1755086820",
									tag: "",
									type: []
								},
								{
									name: "TOZO S7",
									buy_now_url: "/products/s7-smartwatch",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_S7.png?v=1739168680",
									tag: "",
									type: []
								},
								{
									name: "TOZO S6",
									buy_now_url: "/products/s6-smartwatch",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_S6.png?v=1728269260",
									tag: "",
									type: []
								},
								{
									name: "TOZO S5",
									buy_now_url: "/products/s5",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_S5.webp?v=1720092872",
									tag: "",
									type: []
								},
								{
									name: "TOZO S4",
									buy_now_url: "/products/s4",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_S4.webp?v=1720092872",
									tag: "",
									type: []
								},
								// {
								// 	name: "TOZO S3",
								// 	buy_now_url: "/products/s3",
								// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_S3.webp?v=1720092872",
								// 	tag: "",
								// 	type: []
								// }
							],
						}
					],
					classification: [],
					all_list:{
						name: this.$t('nav_box.WATCHES.Shop_All_Watches'),
						url: "/collections/Watches"
					},
					filter_list:[]
				},
				
				{
					series: "SPEAKERS",
					series_url: "/collections/speaker",
					product_collection:[
						{
							id: "SPEAKERS",
							type_name: this.$t('nav_box.title.SPEAKERS'),
							type_url: "",
							product_list:[
								{
									name: "TOZO PA2",
									buy_now_url: "/products/pa2",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_PA2.webp?v=1720092872",
									tag: "",
									type: []
								},
								{
									name: "TOZO PA1",
									buy_now_url: "/products/pa1",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_PA1.webp?v=1720092872",
									tag: "",
									type: []
								},
								{
									name: "TOZO PE1",
									buy_now_url: "/products/pe1-speaker",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_PE1.png?v=1730702681",
									tag: "",
									type: []
								},
								{
									name: "TOZO PM1",
									buy_now_url: "/products/pm1",
									img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_pm1_new.png?v=1755086820",
									tag: "",
									type: []
								},
							],
						}
					],
					classification: [],
					all_list:{
						name: this.$t('nav_box.SPEAKERS.Shop_All_Speakers'),
						url: "/collections/speaker"
					},
					filter_list:[]
				}
			],
			support:{
				title: this.$t('nav_box.SUPPORT.SERVICES'),
				text_list: [
					{
						name: this.$t('nav_box.SUPPORT.Support_Center'),
						url: "/pages/support"
					},
					{
						name: this.$t('nav_box.SUPPORT.Process_Warranty'),
						url: "/pages/process-a-warranty"
					},
					{
						name: this.$t('nav_box.SUPPORT.Order_Tracker'),
						url: "/apps/17TRACK"
					},
					{
						name: this.$t('nav_box.SUPPORT.Privacy_Center'),
						url: "/pages/privacy-policy"
					},
					{
						name: this.$t('nav_box.SUPPORT.Contact_Us'),
						url: "/pages/contact-us"
					}
				],
				icon_list: [
					{
						name: this.$t('nav_box.SUPPORT.FAQs'),
						icon_name: "header_faq",
						url: "/pages/faq"
					},
					{
						name: this.$t('nav_box.SUPPORT.Support_Videos'),
						icon_name: "header_SupportVideos",
						url: "/pages/videotutorial"
					},
					// {
					// 	name: "CYBER_MONDAY",
					// 	icon_name: "header_Troubleshooting",
					// 	url: "/pages/black-friday-cyber-monday-sale"
					// },
					{
						name: this.$t('nav_box.SUPPORT.Manuals'),
						icon_name: "header_quickGuide",
						url: "/pages/manuals"
					},
					{
						name: this.$t('nav_box.SUPPORT.Warranty_Info'),
						icon_name: "header_warranty-policy",
						url: "/pages/warranty-policy"
					},
					// {
					// 	name: "APPs Download",
					// 	icon_name: "header_APPsUpgrade",
					// 	url: "/pages/airyear"
					// }
				]
			},
			explore_list:[
				{
					title: this.$t('nav_box.EXPLORE.ACTIVITIES'),
					text_list: [
						// {
						// 	name: this.$t('nav_box.title.Campaign'),
						// 	url: "#"
						// },
						{
							name: this.$t('nav_box.EXPLORE.CES_2026'),
							url: "/pages/ces-2026"
						},
						{
							name: this.$t('nav_box.EXPLORE.CES_2025'),
							url: "/pages/ces-2025"
						},
						{
							name: this.$t('nav_box.EXPLORE.CES_2024'),
							url: "/pages/ces-2024"
						},
						{
							name: this.$t('nav_box.EXPLORE.NC20_Pro_Coming'),
							url: "/pages/nc20-pro-coming"
						},
						// {
						// 	name: this.$t('nav_box.EXPLORE.NC20_Available'),
						// 	url: "/pages/nc20-launch"
						// },
					]
				},
				{
					title: this.$t('nav_box.EXPLORE.PROMOTION'),
					text_list: [
						{
							name: this.$t('nav_box.EXPLORE.HT3_Coming_Soon'),
							url: "/pages/ht3-coming-soon"
						},
						{
							name: this.$t('nav_box.EXPLORE.CHRISTMAS_SALE'),
							url: "/pages/christmas-sale"
						},
						{
							name: this.$t('nav_box.EXPLORE.TOZO_Coupon'),
							url: "/pages/coupon"
						},
						// {
						// 	name: this.$t('nav_box.EXPLORE.Halloween_Sale'),
						// 	url: "/pages/halloween-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.HOT_SALE'),
						// 	url: "/collections/hot-sales"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.Back_To_School'),
						// 	url: "/pages/back-to-school"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.SUMMER_SALE'),
						// 	url: "/pages/summer-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.PRIME_DAY'),
						// 	url: "/pages/prime-day-deals"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.PRIME_DAY'),
						// 	url: "/pages/prime-day-deals"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.INDEPENDENCE_DAY'),
						// 	url: "/pages/independence-day-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.FATHERS_DAY'),
						// 	url: "/pages/fathers-day-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.EARTH_DAY_SALE'),
						// 	url: "/pages/mothers-day-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.EARTH_DAY_SALE'),
						// 	url: "/pages/earth-day-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.VALENTINE_S_DAY'),
						// 	url: "/pages/valentines-day-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.SOUND_DEALS'),
						// 	url: "/pages/sound-deals"
						// },
						// {
						// 	name: "HOT SALE",
						// 	url: "/collections/hot-sales"
						// },
						{
							name: this.$t('nav_box.EXPLORE.TOZOAiryEar'),
							url: "/pages/airyear"
						}
					]
				},
				{
					title: this.$t('nav_box.EXPLORE.CLUB'),
					text_list: [
						// {
						// 	name: "Community",
						// 	url: "#"
						// },
						{
							name: this.$t('nav_box.EXPLORE.Blog'),
							url: "/blogs/news"
						},
						{
							name: this.$t('nav_box.EXPLORE.Forum'),
							url: "Forum"
						},
						// {
						// 	name: "Press & video",
						// 	url: "#"
						// },
					]
				},
				{
					title: this.$t('nav_box.EXPLORE.BRAND'),
					text_list: [
						{
							name: this.$t('nav_box.EXPLORE.Our_Story'),
							url: "/pages/Our-Story"
						},
						{
							name: this.$t('nav_box.EXPLORE.Technology'),
							url: "/pages/technology"
						},
						// {
						// 	name: "Newsroom",
						// 	url: "#"
						// }
					]
				},
				{
					title: this.$t('nav_box.EXPLORE.TOZO_Distrbutor_Portal'),
					text_list: [
						{
							name: this.$t('nav_box.EXPLORE.Become_a_Distribution_Partner'),
							url: "https://b2b.tozostore.com/"
						},
					]
				}
			]
		}
	},
	
	// 监听
	watch: {
		"$store.state.userinfo": {
			handler: function (newValue, oldValue) {
				this.userData = this.$store.state.userinfo
			},
			deep: true
		},
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
	  that = this
	},
  
	mounted() {
		this.SetNavSelected(this.menuNav[0])
		this.set_userData()
	},
  
	methods:{
		go_page_url(url){
			if(url == 'Forum'){
				this.$emit("close_menu")
				this.$router.push({
					name: "home",
					params: {}
				})
			}else{
				if (url && url.includes('http')) {
				   // 新窗口打开外部URL
				   window.open(url, '_blank');
				} else {
				   // 使用路由跳转到内部页面
				   this.$go_official_website_page(url);
				}
			}
		},
		
		set_userData(){
			// let that = this
			// setTimeout(()=>{
			// 	that.userData = that.$store.state.userinfo,
			// 	that.userDataShow = true
			// }, 2000)
		},
		
		SetNavSelected(item){
			if(item.pageUrl && item.pageUrl != ''){
				this.$go_official_website_page(item.pageUrl)
			}else{
				this.NavSelected = item.id
				this.get_product_list = this.get_product_list_fun(item.id)
			}
		},
		
		li_dropdown_mouseover(boj){
			this.get_product_list = this.get_product_list_fun(boj)
		},
		
		get_product_list_fun(ID){
			let arr = []
			this.product_arr.forEach((item)=>{
				if(item.series == ID){
					arr = item
				}
			})
			// let list = []
			// let that = this
			// if(boj.classification && boj.classification.length > 0){
			// 	boj.product_list.forEach((item)=>{
			// 		if(item.type.map(item => item.toLowerCase()).includes(that.ficationActive.toLowerCase())){
			// 			list.push(item)
			// 		}
			// 	})
			// }else{
			// 	list = boj.product_list
			// }
			return arr
		},
		
		//查看 粉丝或关注人信息
		check_information(item){
			console.log(item)
			console.log(this.$route.name)
			this.$emit("close_menu")
			if(this.$route.name == 'user-profile'){ return }
			this.$router.push({
			   name: "user-profile",
			   params: {}
			})
		},
		
		//登录
		login_in(){
			console.log('login_in')
			let host = process.env.VUE_APP_API_URL_LOGIN
			let url = `${host}&locale=${this.$language}`
			window.location.href = url;
		},
		
		// 退出
		log_out() {
			let decodedCookies = {};
			let cookieValue = document.cookie;
			let domain = process.env.VUE_APP_API_URL_domain
		  if(cookieValue && cookieValue.length != 0){
		    cookieValue.split(';').forEach(cookie => {
		      let parts = cookie.split('=');
		      let key = decodeURIComponent(parts[0].trim()); //decodeURIComponent反转译
		      let value = decodeURIComponent(parts[1]);
		      decodedCookies[key] = value;
				if(key == 'DIV_authentication' || key == 'token' || key == 'login_token'){
					let toekn = ''
					let maxAge = new Date()
					if(key == 'DIV_authentication'){
					  document.cookie = `DIV_authentication=${toekn};domain=${domain};max-age=${maxAge};path=/`
					  console.log(decodedCookies.DIV_authentication)
					}
					if(key == 'token'){
					  document.cookie = `token=${toekn};domain=${domain};max-age=${maxAge};path=/`
					  console.log(decodedCookies.token)
					}
					if(key == 'login_token'){
					  document.cookie = `login_token=${toekn};domain=${domain};max-age=${maxAge};path=/`
					  console.log(decodedCookies.login_token)
					}
				}
		    });
		    console.log(decodedCookies.DIV_authentication)
		    console.log(domain)
		  }
			console.log(document.cookie)
			this.$cookie.delete('login_token') //社区接口的token
			this.$cookie.delete('login_token_expire') //社区接口的token的过期时间
			this.$cookie.delete('token') //官网接口的token
			this.$cookie.delete('DIV_authentication') //获取token的key
			this.$cookie.delete('DIV_authentication_expire') //获取token的key的过期时间
			this.$cookie.delete('user')
			this.$store.dispatch('signOut', [this, ''])
			setTimeout(()=>{
				this.$router.push({name: "home"})
				location.reload()
			}, 1500)
		  // if(this.$route.name == 'Checkout'){
		  //   this.$router.push({name: "index"})
		  // }else if(this.$route.name == 'userinfo'){
		  //   this.$router.push({name: "index"})
		  // }else{
		  //   location.reload()
		  // }
		},
	
	}
}
</script>

<style lang="less" scoped>
	
	.product_list_box{
		/* display: flex; */
		width: 100%;
		/* flex-wrap: wrap; */
		
	}
	.collection_item_box{
		width: 100%;
		margin-top: 30px;
		&:first-child{
			margin-top: 0px;
		}
		.type_name_box{
			display: flex;
			justify-content: space-between;
			margin-bottom: 15px;
			.type_name{
				font-size: 13px;
				color: #000000;
				line-height: 1;
				font-weight: 600;
			}
		}
		.type_name_box_pointer{
			cursor: pointer;
		}
	}
	.item_list_box {
		display: flex;
		width: 100%;
		flex-wrap: wrap;
	}
	.item_box{
	  width: calc(calc(100% - 10px) / 2);
	  border-radius: 8px;
	  background: #F6F7FA;
	  padding: 15px 2px;
	  margin-right: 10px;
	  margin-bottom: 10px;
	  cursor: pointer;
		.product_img{
			width: 100%;
			img{
				width: 100%;
			}
		}
		.product_header_tag{
			margin-top: 5px;
			min-height: 20px;
			align-items: center;
			display: flex;
			justify-content: center;
			color: #E80909;
			font-size: 10px;
		}
		.nav_product_name{
			margin-top: 5px;
			min-height: 20px;
			align-items: center;
			display: flex;
			justify-content: center;
			color: #3C3C3C;
			font-size: 12px;
			line-height: 1.3;
			text-align: center;
		}
	}
	
	.category-product-all{
		cursor: pointer;
		margin-top: 20px;
		min-height: 20px;
		align-items: center;
		display: flex;
		justify-content: flex-start;
		font-size: 14px;
	}
	.category-product-all span{
	  align-items: center;
	  display: flex;
	  color: #7A7A7A;
	}
	.category-product-all .el-icon-arrow-right{
	  width: 10px;
	  font-size: 14px;
	  margin-left: 5px;
	  margin-top: 4px;
	}
	.bottom-box{
	  padding: 10px 10px;
	}
	.language_box{
		margin-top: 10px;
		width: 100%;
		display: flex;
		align-items: center;
	}
	.userData{
		display: flex;
		
		.login_box,
		.username{
			margin-left: 5px;
			color: #000000;
			width: calc(100% - 40px);
			display: flex;
			align-items: center;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap; /* 防止换行 */
		}
	}
	.log_out_box{
		margin-top: 10px;
		display: flex;
		align-items: center;
		padding: 5px 0px;
		cursor: pointer;
		width: 100%;
		font-size: 14px;
		color: #409EFF;
		i,
		.log_out{
			color: #409EFF;
		}
	}
	.avatar{
		border: 1px #f5f5f5 solid;
		width: 35px;
		height: 35px;
		cursor: pointer;
		overflow: hidden;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		img{
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
   .header_menu_list *{
      font-family: Poppins;
      box-sizing: border-box;
   }
   .header_menu_list {
		min-height: calc(100vh - 50px);
		width: 100%;
      padding: 0px;
		display: flex;
      width: 100%;
      background: #ffffff;
		position: sticky;
		width: 100%;
		background: #ffffff;
		top: 0;
		max-height: calc(100vh - 50px);
	}
	.header_menu_left{
		min-height: 100%;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		padding: 30px 0px 0px 0px;
		border-right: 1px solid #ececec;
		overflow: auto;
		min-height: calc(100vh - 50px);
	}
	.header_menu_nav{
		width: 100%;
	}
	.header_menu_content{
		width: calc(100% - 0px);
		// width: calc(100% - 180px);
		overflow: auto;
		max-height: 100vh;
	}
	.menu_content{
		width: 100%;
	}
	
	.header_menu_nav{
	  margin-bottom: 25px;
	}
	.header_menu_nav .mobileClassName{
	  color: #000000;
	  line-height: 1.3;
	  padding-left: 10px;
	  display: block;
	  margin-bottom: 30px;
	  position: relative;
	  padding-top: 3px;
	  padding-bottom: 3px;
	  cursor: pointer;
	}
	.header_menu_nav .mobileClassName:last-child{
	  margin-bottom: 0px;
	}
	.header_menu_nav .mobileClassName.divActive:after {
	  content: "";
	  width: 5px;
	  height: 1.5rem;
	  background: #000000;
	  position: absolute;
	  top: 0;
	  left: 0;
	  z-index: 1;
	}
	.tozo_hot_box{
	  display: flex;
	  position: relative;
	}
	.mobileClassName .tozo_hot_img{
	  margin-left: 0px;
	  margin-top: -10px;
	}
	.mobileClassName .tozo_hot_img img{
	  display: block;
	  width: 100%;
	  max-width: 22px;
	  /* max-width: 12px; */
	}
	
		.category-product-filterate-box{
			margin-top: 40px;
			margin-bottom: 20px;
		}
		.category-product-filterate-title{
			align-items: center;
			display: flex;
			justify-content: flex-start;
			color: #000000;
			font-weight: 600;
		}
		.category-product-filterate-text{
			margin-top: 15px;
			align-items: center;
			display: flex;
			justify-content: flex-start;
			flex-direction: column;
		}
		.filterate-type{
			cursor: pointer;
			align-items: center;
			display: flex;
			justify-content: space-between;
			padding: 15px 5px 15px 0px;
			border-bottom: .01rem solid #ececec;
			width: 100%;
			color: #3C3C3C;
			font-size: 14px;
		}
		.category-product-all.filterate-type{
			border-bottom: 0px;
			font-size: 14spx;
		}
		.filterate-type > .name{
			width: 100%;
			display: block;
			font-size: 12px;
			color: #3C3C3C;
		}
		.el-icon-arrow-right{
		  width: 10px;
		  font-size: 14px;
		  color: #3C3C3C;
		}
		.mobile-support-section-iconBox{
		  width: 100%;
		  margin-top: 20px;
		  display: flex;
		  flex-wrap: wrap;
		}
		.support-icon-img{
		  width: 100%;
		  align-items: center;
		  display: flex;
		  justify-content: center;
		}
		.support-icon-name{
		  margin-top: 18px;
		  color: #3C3C3C;
		  font-size: 12px;
		  line-height: 1.3;
		  align-items: center;
		  display: flex;
		  justify-content: center;
		  text-align: center;
		}
		.leftBox-login-section .mobile-menu__item{
		  align-items: flex-start;
		  display: flex;
		  width: 100%;
		  padding: 0 !important;
		}
		.leftBox-login-section .mobile-menu__item .icon{
		  min-width: 20px;
		  margin-top: 2px;
		  margin-right: 8px;
		}
		.support-a-item-box{
		  width: calc(calc(100% - 10px) / 2);
		  border-radius: 8px;
		  background: #F6F7FA;
		  padding: 42px 5px;
		  margin-right: 10px;
		  margin-bottom: 10px;
		  max-height: 144px;
		  cursor: pointer;
		}
	
	.explore-section-box{
		display: flex;
		flex-direction: column;
	}
	.explore-section{
		margin-bottom: 50px;
	}
	.filterate-title{
		align-items: center;
		display: flex;
		justify-content: flex-start;
		color: #000000;
		font-size: 13px;
		line-height: 1;
		font-weight: 600;
	}
	.filterate-text-box{
	  margin-top: 15px;
	  align-items: center;
	  display: flex;
	  justify-content: flex-start;
	  flex-direction: column;
	}
	.filterate-text{
		cursor: pointer;
		align-items: center;
	   display: flex;
	   justify-content: space-between;
	   padding: 15px 5px 15px 0px;
	   border-bottom: .01rem solid #ececec;
	   width: 100%;
	   color: #3C3C3C;
	   font-size: 12px;
	}
	@media only screen and (max-width: 600px) {
		.mobile-menu-div-rightBox{
			padding: 35px 10px 15px 10px;
		}
		.item_box:nth-child(2n){
			margin-right: 0px;
		}
		.support-a-item-box:nth-child(2n){
			margin-right: 0px;
		}
	}
	@media only screen and (min-width: 1024px) {
		.header_menu_left{
			min-width: 180px;
		}
		.header_menu_nav .mobileClassName {
		   font-size: 15px;
		}
	}
	@media only screen and (min-width: 769px) and (max-width: 1024px) {
		.header_menu_left{
			min-width: 180px;
			height: 100%;
		}
		.header_menu_content{
			width: calc(100% - 0px);
			// width: calc(100% - 180px);
			padding: 35px 15px 15px 15px;
		}
	  .leftBox-menu-section .mobileClassName{
	    padding-left: 20px;
	  }
	  .item_box{
	    width: calc(calc(100% - 30px) / 4);
	    margin-right: 10px;
	  }
	  .item_box:nth-child(4n){
	    margin-right: 0px;
	  }
	  .support-a-item-box{
	    width: calc(calc(100% - 30px) / 4);
	    margin-right: 10px;
	  }
	  .support-a-item-box:nth-child(4n){
	    margin-right: 0px;
	  }
	}
	
	@media only screen and (min-width: 600px) and (max-width: 768px) {
		.header_menu_left{
			min-width: 170px;
			height: 100%;
		}
		.header_menu_content{
			width: calc(100% - 0px);
			// width: calc(100% - 170px);
			padding: 35px 15px 15px 15px;
		}
		.mobileClassName{
			padding-left: 20px;
		}
		.mobileClassName,
		.mobileClassName .name{
			font-size: 14px;
		}
	  .item_box{
	    width: calc(calc(100% - 20px) / 3);
	    margin-right: 10px;
	  }
	  .item_box:nth-child(3n){
	    margin-right: 0px;
	  }
	  .support-a-item-box{
	    width: calc(calc(100% - 20px) / 3);
	    margin-right: 10px;
	  }
	  .support-a-item-box:nth-child(3n){
	    margin-right: 0px;
	  }
	}
	@media only screen and (min-width: 400px) and (max-width: 600px) {
		.header_menu_left{
			min-width: 130px;
			height: 100%;
		}
		.header_menu_content{
			width: calc(100% - 0px);
			// width: calc(100% - 130px);
			padding: 35px 10px 15px 10px;
		}
		.mobileClassName {
			padding-left: 15px;
		}
		.mobileClassName,
		.mobileClassName .name{
			font-size: 13.5px;
		}
	  
	  .leftBox-login-section .mobile-menu__item .icon {
	    min-width: 20px;
	    margin-top: 0px !important;
	    margin-right: 8px;
	  }
	  .account-sidebar__name{
	    font-size: 14px !important;
	  }
	}
	@media only screen and (max-width: 400px) {
		.header_menu_left{
			min-width: 125px;
			height: 100%;
		}
		.header_menu_content{
			width: calc(100% - 0px);
			// width: calc(100% - 125px);
			padding: 35px 10px 15px 10px;
		}
		.mobileClassName{
			padding-left: 10px;
		}
		.mobileClassName,
		.mobileClassName .name{
			font-size: 13px;
		}
	  .leftBox-login-section .mobile-menu__item .icon {
	    min-width: 20px;
	    margin-top: 0px !important;
	    margin-right: 8px;
	  }
	  .account-sidebar__name{
	    font-size: 14px !important;
	  }
	}
   
</style>
